import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import PostingNoticeWidget from './components/PostingNoticeWidget';

app.initializers.add('butterflycode-posting-notice', () => {
  extend(IndexPage.prototype, 'viewItems', function (items) {
    // Don't add widget on the top page (only show on tag pages)
    const tagSlug = m.route.param('tags');
    if (!tagSlug) return;

    // Add posting notice widget below the WordPress feed widget
    // Using priority -110 to place it below wp-feed which uses -100
    items.add('postingNotice', <PostingNoticeWidget />, -110);
  });
});
